import { SystemStyleObject } from "@chakra-ui/react";

export const MAPLIBRE_STYLES: SystemStyleObject = {
  ".maplibregl-popup-close-button": {
    fontSize: "1.5rem",
    width: "2rem",
    height: "2rem",
    top: "-0.25rem",
    right: "-0.25rem",
    rounded: "base",
  },
  ".maplibregl-control-container": {
    fontSize: "70%",
  },
  ".maplibregl-map": {
    font: "inherit",
  },
  ".maplibregl-popup-content": {
    rounded: "base",
    bg: "brand.bg",
  },
};
